import React from "react";
import { connect } from "react-redux";
import AutorizacionActions from "../../../stores/autorizacion/Actions";
import CustomInput from "../../../components/CustomForm/CustomInput";
import CustomButton from "../../../components/CustomButton/CustomButton";
import CheckRender from "../../../components/Common/CheckRender";
import {
  FormWrapper,
  Form,
  FormGroup,
} from "../../../components/CustomForm/FormStyles";
import Colors from "../../../themes/Colors";
import { useMountEffect } from "../../../hooks/LifeCycle";
import moment from "moment";
import { DATE_FORMATS, TIME_SCALE } from "../../../utils/Constant";
import useEmpresa from "../../../hooks/useEmpresa";
import { camposCompletos } from "../../../utils/ValidationUtil";
import { ALERTAS_GENERICAS } from "../../../utils/AlertasGenericas";
import { MAXIMO_DIAS_CONSULTA_DIAGNOSTICOS } from "../utils/AutorizacionConstant";

const AutorizacionDiagnosticoForm = (props) => {
  const {
    formAutorizacionDiagnosticoData,
    getAutorizacionesDiagnosticoLoading,
  } = props;

  const empresa = useEmpresa();

  const { prestador } = props?.authUserData;

  useMountEffect(() => {
    let startDate = moment(new Date())
      .subtract(MAXIMO_DIAS_CONSULTA_DIAGNOSTICOS, TIME_SCALE.dia)
      .format(DATE_FORMATS.middledash_ymd);

    let today = moment(new Date()).format(DATE_FORMATS.middledash_ymd);

    consultarUltimasAutorizaciones(startDate, today);

    props.formAutorizacionDiagnostico({
      ...formAutorizacionDiagnosticoData,
      fechaInicio: startDate,
      fechaFin: today,
    });
  });

  const onStateChange =
    (key, format = null) =>
    (value) => {
      props.formAutorizacionDiagnostico({
        ...formAutorizacionDiagnosticoData,
        [key]: format ? format(value) : value,
      });
    };

  const consultarUltimasAutorizaciones = (fechaInicio, fechaFin) => {
    props.getAutorizacionesDiagnostico({
      numeroBusqueda: null,
      fechaInicio,
      fechaFin,
      prefijo: empresa?.PREFIJO_AUTORIZACION,
      compania: empresa?.CODIGO,
      tipoReclamante: prestador?.tipoPss,
      reclamante: prestador?.codigo,
      formAutorizacionDiagnosticoData: formAutorizacionDiagnosticoData,
      formHandler: props.formAutorizacionDiagnostico,
    });
  };

  const buscarAutorizacionesDiagnostico = () => {
    const { fechaInicio, fechaFin, numeroBusqueda } =
      formAutorizacionDiagnosticoData;

    let mensajeValidacion = null;

    if (!camposCompletos({ fechaInicio, fechaFin })) {
      mensajeValidacion = ALERTAS_GENERICAS.CAMPOS_REQUERIDOS;
    } else if (moment(fechaInicio).isAfter(fechaFin)) {
      mensajeValidacion = ALERTAS_GENERICAS.FECHA_DESDE_HASTA_INVALIDA;
    }

    const rangoDias = moment(fechaFin).diff(moment(fechaInicio), "days");

    if (rangoDias > MAXIMO_DIAS_CONSULTA_DIAGNOSTICOS) {
      mensajeValidacion = `El rango de fechas debe ser menor de ${MAXIMO_DIAS_CONSULTA_DIAGNOSTICOS} días.`;
    }

    if (mensajeValidacion) {
      props.formAutorizacionDiagnostico({
        ...formAutorizacionDiagnosticoData,
        alertConfig: {
          type: "info",
          title: "¡Hola!",
          message: mensajeValidacion,
          onConfirm: () => {
            props.formAutorizacionDiagnostico({
              ...formAutorizacionDiagnosticoData,
              showAlert: false,
            });
          },
        },
        showAlert: true,
      });
      return;
    }

    props.getAutorizacionesDiagnostico({
      numeroBusqueda,
      fechaInicio,
      fechaFin,
      prefijo: empresa?.PREFIJO_AUTORIZACION,
      compania: empresa?.CODIGO,
      tipoReclamante: prestador?.tipoPss,
      reclamante: prestador?.codigo,
      formAutorizacionDiagnosticoData: formAutorizacionDiagnosticoData,
      formHandler: props.formAutorizacionDiagnostico,
    });
  };
  
  return (
    <CheckRender allowed={false}>
      <FormWrapper borderColor={Colors.transparent}>
        <Form justifyContent={"space-between"}>
          <FormGroup>
            <CustomInput
              type={"text"}
              placeholder={`No. Autorización`}
              label={"No. Autorización"}
              isLabelWithContainer={true}
              labelWidth={"270px"}
              width={"250px"}
              value={formAutorizacionDiagnosticoData?.numeroBusqueda}
              onChange={onStateChange("numeroBusqueda")}
            />
          </FormGroup>
          <FormGroup>
            <CustomInput
              type={"date"}
              maxDate={formAutorizacionDiagnosticoData?.fechaFin}
              required={true}
              placeholder={"Fecha Desde"}
              label={"Desde"}
              isLabelWithContainer={true}
              labelWidth={"270px"}
              width={"250px"}
              value={formAutorizacionDiagnosticoData?.fechaInicio}
              onChange={onStateChange("fechaInicio")}
            />
          </FormGroup>
          <FormGroup>
            <CustomInput
              type={"date"}
              minDate={formAutorizacionDiagnosticoData?.fechaInicio}
              required={true}
              placeholder={"Fecha Hasta"}
              label={"Hasta"}
              isLabelWithContainer={true}
              labelWidth={"270px"}
              width={"250px"}
              value={formAutorizacionDiagnosticoData?.fechaFin}
              onChange={onStateChange("fechaFin")}
            />
          </FormGroup>
          <FormGroup>
            <CustomButton
              label={"Buscar"}
              onClick={buscarAutorizacionesDiagnostico}
              isLoading={getAutorizacionesDiagnosticoLoading}
              height={"46px"}
              width={"100px"}
            />
          </FormGroup>
        </Form>
      </FormWrapper>
    </CheckRender>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,

  formAutorizacionDiagnosticoData:
    state.autorizacion.formAutorizacionDiagnosticoData,
  formAutorizacionDiagnosticoLoading:
    state.autorizacion.formAutorizacionDiagnosticoLoading,

  getAutorizacionesDiagnosticoLoading:
    state.autorizacion.getAutorizacionesDiagnosticoLoading,
});

const mapDispatchToProps = {
  formAutorizacionDiagnostico: AutorizacionActions.formAutorizacionDiagnostico,
  getAutorizacionesDiagnostico:
    AutorizacionActions.getAutorizacionesDiagnostico,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(AutorizacionDiagnosticoForm);
